<tc-setup-grid
    #setupGrid
    [readOnly]="false"
    [colDefConfig]="colDefConfig"
    [setupGridComp]="this"
    [dataSource]="this"
    [cellEditingStart]="cellEditingStart">
</tc-setup-grid>
